<template>
  <div class="home">
<!--    用户设备统计-->
    <user-count/>
<!--    商家统计-->
    <shop-device-count/>
    <el-row :gutter="15">
      <el-col :span="12" :xs="24">
        <bill-revenue/>
      </el-col>
      <el-col :span="12" :xs="24">
        <el-card>
          <div class="chart">
<!--    财务收入-->
            <bill-month/>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="8" :xs="24">
        <el-card>
          <div class="chart">
<!--    商家排行-->
            <shop-rank/>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" :xs="24">
        <el-card>
          <div class="chart">
<!--    商家类型-->
            <shop-type/>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" :xs="24">
        <el-card>
          <div class="chart">
<!--    设备类型-->
            <device-type/>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import UserCount from "./components/UserCount"
  import ShopDeviceCount from "./components/ShopDeviceCount"
  import BillMonth from "./components/BillMonth"
  import BillRevenue from "./components/BillRevenue"
  import ShopType from "./components/ShopType"
  import DeviceType from "./components/DeviceType"
  import ShopRank from "./components/ShopRank"
  export default {
    name: "index",
    components: {BillRevenue, UserCount, ShopDeviceCount, BillMonth, ShopType, DeviceType, ShopRank},
  }
</script>

<style scoped lang="scss">
.home {
  padding: 15px;
  .chart {
    height: 400px;
  }
}
</style>
